var map = {
	"./comunebg/images/splashLogo.png": "b58d",
	"./default/images/splashLogo.png": "a565",
	"./emergency/images/splashLogo.png": "4da5",
	"./hoval/images/splashLogo.png": "6156",
	"./sorint/images/splashLogo.png": "7a294",
	"./vimm/images/splashLogo.png": "2f67"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "327a";